export class ListAtlasOrganizationsResponse {
    'organizations';
    'nextToken';
    'totalCount';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "organizations",
            "baseName": "organizations",
            "type": "Array<AtlasOrganization>",
            "format": ""
        },
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListAtlasOrganizationsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
